import React from "react";

const statusStyle = status => ["Healthy", "Excellent", "Online"].includes(status) ? "healthy" : status === "Poor" ? "poor" : status === "Critical" ? "critical" : status === "Fair" ? "fair" : "unknown";
// Keep these display bands aligned with WPF SignalScoreVisuals.GetStatus.
export const scoreStyle = score => !Number.isFinite(score) ? "unknown" : score >= 90 ? "healthy" : score >= 80 ? "fair" : score >= 70 ? "poor" : "critical";

export default function MemberSignalMetrics({ signal, name, renderScore }) {
  const offline = signal?.SignalOverallStatus === "Offline";
  const metrics = [
    ["Signal Score", !offline && Number.isFinite(signal?.SignalScore) ? `${signal.SignalScore}%` : "Unavailable"],
    ["Workspace", offline ? "Offline" : signal?.SignalWifiStatus || "Unavailable"],
    ["Network", offline ? "Offline" : signal?.SignalBandwidthStatus || "Unavailable"],
    ["Device", offline ? "Offline" : signal?.SignalSystemStatus || "Unavailable"],
  ];
  return <dl className={`team-member-metrics${renderScore ? " team-member-metrics--gauge" : ""}`} aria-label={`Signal status for ${name}`}>
    {metrics.map(([label, value]) => <div key={label}><dt>{label}</dt>
      <dd className={label === "Signal Score" ? `service-monitor-status team-signal-score--${scoreStyle(offline ? null : signal?.SignalScore)}` : `service-monitor-status telemetry-status--${statusStyle(value)}`}>{label === "Signal Score" && renderScore ? renderScore(offline ? null : signal?.SignalScore) : value}</dd>
    </div>)}
  </dl>;
}
